import { LOCATION_CHANGE } from 'connected-react-router'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import {
  catchError,
  delayWhen,
  filter,
  ignoreElements,
  switchMap
} from 'rxjs/operators'
import { postUniverseView } from 'api/planet/viewUniverse'
import {
  ALL_PRODUCTS_TRACKING_NAME,
  ALL_PRODUCTS_TYPE
} from 'constants/navigation'
import { isCatalogOrUniversePageAction } from 'domain/router'
import { captureException } from 'helpers/raven'
import * as Actions from 'store/actions/index.ts'
import {
  getCountryCode,
  getCultureCode,
  getCurrentResourceSubUniverseId,
  getCurrentResourceSubUniverseName,
  getCurrentResourceUniverseId,
  getCurrentResourceUniverseName,
  getDeviceType,
  getIsSaleFetched,
  getMarketId,
  getOperationCode
} from 'store/selectors'
import { awaitForSaleFetched } from './helpers/resources'

const universeViewEpic = (
  actions$,
  state$
) => (
  actions$.pipe(
    ofType(LOCATION_CHANGE),
    filter(isCatalogOrUniversePageAction),
    delayWhen(_locationChangeAction => getIsSaleFetched(state$.value)
      ? of({})
      : awaitForSaleFetched(actions$, state$)
    ),
    switchMap(_locationChangeAction => {
      const state = state$.value
      const universeName = getCurrentResourceUniverseId(state) === ALL_PRODUCTS_TYPE
        ? ALL_PRODUCTS_TRACKING_NAME
        : getCurrentResourceUniverseName(state)

      const postViewUniverseParams = {
        campaignCode: getOperationCode(state),
        deviceType: getDeviceType(state),
        locale: {
          countryCode: getCountryCode(state),
          cultureCode: getCultureCode(state)
        },
        marketId: getMarketId(state),
        subUniverseKey: getCurrentResourceSubUniverseId(state),
        subUniverseName: getCurrentResourceSubUniverseName(state),
        universeKey: getCurrentResourceUniverseId(state),
        universeName
      }

      return (
        postUniverseView(postViewUniverseParams).pipe(
          ignoreElements(),
          catchError(error => {
            captureException(new Error('Unable to post current (sub)universe visited'), {
              extra: { error }
            })

            return of(Actions.errors.onPostViewUniverseError(error))
          })
        )
      )
    })
  )
)

export default universeViewEpic
